import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";
import type { components } from "../../api/schema.gen";

export type ScreenedBond = components["schemas"]["ScreenedBondDTO"];

export type ScreenerParams = {
  board: string;
  target: number; // десятичная дробь, 0.16 == 16%
  currency: string;
  tax: string;
  fxToday?: number;
  fxFuture?: number;
};

export function useScreener(params: ScreenerParams) {
  return useQuery({
    // queryKey сериализуется библиотекой, обычный объект работает: при тех же
    // полях кеш совпадёт, при изменении — будет новый ключ и новый fetch.
    queryKey: ["screen", params],
    queryFn: async ({ signal }) => {
      const { data, error } = await api.GET("/api/screen", {
        signal,
        params: {
          query: {
            board: params.board,
            target: params.target * 100, // FastAPI ждёт проценты
            tax: params.tax,
            currency: params.currency,
            fx_today: params.fxToday ?? null,
            fx_future: params.fxFuture ?? null,
          },
        },
      });
      if (error || !data) throw new Error(String(error ?? "no data"));
      return data;
    },
    // 5 минут согласовано с интервалом scheduler'а quotes-job — за это окно
    // данные на сервере всё равно не меняются, refetch был бы зря.
    staleTime: 5 * 60_000,
  });
}
